import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ProfileHeaderProps {
  email?: string;
  onLogout: () => void;
}

const ProfileHeader = ({ email, onLogout }: ProfileHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Profile</h1>
        {email && (
          <p className="text-sm text-muted-foreground mt-1">{email}</p>
        )}
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={onLogout}
        className="text-sm text-muted-foreground hover:text-foreground"
      >
        <LogOut size={16} />
        <span className="ml-1">Log Out</span>
      </Button>
    </div>
  );
};

export default ProfileHeader;